@if (showErrorModal) {
  <app-popup [showHeader]="false">
    <div class="error-image">
      <img src="/assets/images/error-icon.svg" alt="error image" />
    </div>
    <div class="response-content">
      <p class="response-title">Error</p>
      <p class="response-text">{{ modalMessage }}</p>
      <button class="response-cta" (click)="showErrorModal = false">Ok</button>
    </div>
  </app-popup>
}

@if (showSuccessModal) {
  <app-popup [showHeader]="false">
    <div class="success-image">
      <img src="/assets/images/success-icon.svg" alt="success image" />
    </div>
    <div class="response-content">
      <p class="response-title">Success!</p>
      <p class="response-text">{{ modalMessage }}</p>
      <button class="response-cta" (click)="showSuccessModal = false">
        Ok
      </button>
    </div>
  </app-popup>
}

@if (showModalSpinner) {
  <div class="modal-spinner">
    <app-nada-spinner />
  </div>
}
<div class="container">
  <div class="header-contents">
    <div class="filters-section">
      <app-custom-date-select
        class="dropdown date"
        [(ngModel)]="statementDate"
        selectionMode="month-year"
        [minDate]="minDate"
        [maxDate]="maxDate"
        placeholder="Statement Date"
      />
      @if (allDMS.length) {
        <app-custom-dropdown
          class="dropdown"
          [(ngModel)]="dms"
          [options]="allDMS"
          trackBy="name"
          label="DMS / Excel template"
        />
      }
      @if (dms?.name?.toLowerCase() === "other") {
        <input
          type="text"
          class="other-dms-input"
          placeholder="Enter DMS Name"
          [(ngModel)]="otherDmsName"
        />
      }
    </div>
  </div>
  <div class="upload-section">
    <p class="text">Upload Your File</p>
    <div class="upload-container" [ngClass]="{ uploaded: fileUploaded }">
      <label
        for="fileInput"
        class="upload-box"
        (dragover)="onDragOver($event)"
        (drop)="onDrop($event)"
      >
        <input
          type="file"
          id="fileInput"
          hidden
          (change)="onFileSelected($event)"
        />
        <div class="upload-icon">
          <img
            src="/assets/images/upload-icon.svg"
            alt="Upload Icon"
            width="50"
          />
        </div>
        <p>
          <a href="#" (click)="openFileInput($event)">Click here</a> to upload
          your file or drag and drop.
          <span class="required">*</span>
        </p>
        <small
          >Supported formats: Excel files (.xlsx, .xls, .xlsm). Files must be
          unprotected; .xlsx (without macros) is preferred.</small
        >
      </label>
    </div>
    @if (fileUploaded) {
      <div class="upload-status">
        <div class="image-width">
          <img
            src="/assets/images/upload-icon.svg"
            alt="Upload Icon"
            width="50"
          />
        </div>
        <div style="width: 480px">
          <div class="file-info">
            <span>{{ fileName }}</span>
            <button (click)="removeFile()" class="delete-button">
              <img src="/assets/images/delete-icon.svg" alt="Delete Icon" />
            </button>
          </div>
          <div class="progress-bar">
            <div
              class="progress"
              [style.width.%]="uploadProgress"
              [style.background-color]="progressColor"
            ></div>
          </div>
          @if (uploadProgress === 100) {
            <p class="success-message">
              Click on upload button to upload file.
            </p>
          } @else {
            <p class="success-message">Verifying file...</p>
          }
        </div>
      </div>
    }
    <div style="display: flex; justify-content: center">
      <button
        [disabled]="uploadProgress < 100"
        class="upload-btn"
        (click)="uploadFile()"
      >
        Upload
      </button>
    </div>
  </div>
</div>
